<template>
  <div class="documentation">
    <h1>项目文档</h1>
    <div class="page">
    <div class="toc">
      <h2>目录</h2>
      <ul>
        <li v-for="(item, index) in toc" :key="index">
          <a :href="'#' + item.id">{{ item.title }}</a>
          <ul v-if="item.subtitles">
            <li v-for="(subtitle, idx) in item.subtitles" :key="idx">
              <a :href="'#' + subtitle.id">{{ subtitle.title }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </div>

    <div class="content">
      <div v-for="(section, index) in sections" :key="index">
        <h2 v-if="section.type === 'title'" :id="section.id">{{ section.text }}</h2>
        <h3 v-else-if="section.type === 'subtitle'" :id="section.id">{{ section.text }}</h3>
        <p v-else>{{ section.text }}</p>
      </div>
      <p><a href="wxloginSDK.zip">下载文档和SDK</a></p>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sections: [],
      toc: [],
    };
  },
  methods: {
    async loadDocument() {
      try {
        const response = await fetch('./document.txt');
        const text = await response.text();
        this.parseDocument(text);
      } catch (error) {
        console.error('Failed to load document:', error);
      }
    },
    parseDocument(text) {
      const lines = text.split('\n');
      let currentTitle = null;
      lines.forEach((line) => {
        line = line.trim();
        if (line.startsWith('###')) {
          const title = line.replace('###', '').trim();
          const id = `title-${this.sections.length}`;
          this.sections.push({ type: 'title', text: title, id });
          currentTitle = { title, id, subtitles: [] };
          this.toc.push(currentTitle);
        } else if (line.startsWith('##')) {
          const subtitle = line.replace('##', '').trim();
          const id = `subtitle-${this.sections.length}`;
          this.sections.push({ type: 'subtitle', text: subtitle, id });
          currentTitle?.subtitles.push({ title: subtitle, id });
        } else if (line) {
          this.sections.push({ type: 'paragraph', text: line });
        }
      });
    },
  },
  mounted() {
    this.loadDocument();
  },
};
</script>

<style scoped>
.documentation {
  padding: 20px;
}

.page{
  display: flex;
}

.toc {
  width:300px;
  margin-bottom: 20px;
  padding-bottom: 10px;
}

.toc h2 {
  font-size: 1.5em;
}

.toc ul {
  list-style-type: none;
  padding-left: 20px;
}

.toc li {
  margin: 5px 0;
}

.content{
  width:100%;
}

.content h2, .content h3 {
  margin-top: 20px;
}

.content p {
  margin-top: 10px;
  line-height: 1.6;
}
</style>
